// extracted by mini-css-extract-plugin
export default {"topCards-container":"TopCards_topCards-container__t4led"};